import axios from 'axios';
import API_URL from './baseURL';

const auth = (token) => ({ headers: { Authorization: `Bearer ${token || localStorage.getItem('authToken')}` } });

export const getVehicleSummary = async (vehicleId, token) => {
  const res = await axios.get(`${API_URL}/telematics/vehicles/${vehicleId}/summary`, auth(token));
  return res.data?.data; // { device, position, score, crashProtection }
};

// Every owned vehicle's last known position in one call, for the dashboard map.
export const getFleetPositions = async (token) => {
  const res = await axios.get(`${API_URL}/telematics/fleet`, auth(token));
  return res.data?.data; // { vehicles: [...], equipped, live }
};

// Admin only: every tracked vehicle on the platform, whoever owns it. A
// separate endpoint from getFleetPositions on purpose — see the controller.
export const getAllFleetPositions = async (token) => {
  const res = await axios.get(`${API_URL}/telematics/fleet/all`, auth(token));
  return res.data?.data; // { vehicles: [...], equipped, live }
};

export const requestDevice = async (vehicleId, token) => {
  const res = await axios.post(`${API_URL}/telematics/device-requests`, { vehicleId }, auth(token));
  return res.data?.data?.request;
};

export const immobilizeVehicle = async (vehicleId, token) => {
  const res = await axios.post(`${API_URL}/telematics/vehicles/${vehicleId}/immobilize`, {}, auth(token));
  return res.data?.data;
};
export const mobilizeVehicle = async (vehicleId, token) => {
  const res = await axios.post(`${API_URL}/telematics/vehicles/${vehicleId}/mobilize`, {}, auth(token));
  return res.data?.data;
};
